module.exports = __webpack_public_path__ + "img/9788984142343.1a2c9487.jpg";